// User redirection constants
export const CHANGE_PASSWORD = 'CHANGEPASSWORD';
export const GDPR = 'GDPR';
export const CHANGE_PASS_PATH = '/app/user/change-password';
export const GDPR_PATH = '/app/user/gdpr-terms';
